import React from 'react';
import './KnowledgeHub.css';

const KnowledgeHub = () => {
    const mediumUrl = 'https://medium.com/@ashutoshshashi';
    const youtubeChannelUrl = 'https://www.youtube.com/@ashutoshshashi';
    const newsletterUrl =
        'https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7133315405330214912';
    const udemyUrl =
        'https://www.udemy.com/user/ashutosh-shashi-4/';

    return (
        <section id="knowledgeHub" className="knowledge-hub">
            <div className="kh-inner">
                <header className="section-header kh-header">
                    <div className="section-kicker">Knowledge Hub</div>
                    <h2>Knowledge Hub</h2>
                    <p>
                        Videos, articles, newsletters, and courses created for developers,
                        architects, and technology leaders growing into larger responsibilities.
                    </p>
                </header>

                <div className="kh-layout">
                    <div className="kh-main">
                        <article className="kh-card kh-card-video">
                            <div className="kh-card-heading">
                                <span>YouTube</span>
                                <h3>Ashutosh Shashi on YouTube</h3>
                            </div>
                            <p>
                                Exploring AI, emerging technology, software architecture, and the
                                changing future of engineering through practical insights and fresh
                                perspectives.
                            </p>
                            <div className="kh-inline-links">
                                <a href={youtubeChannelUrl} target="_blank" rel="noopener noreferrer" className="kh-secondary-link">Watch Videos →</a>
                                <a href={`${youtubeChannelUrl}?sub_confirmation=1`} target="_blank" rel="noopener noreferrer" className="kh-secondary-link">Subscribe →</a>
                            </div>
                        </article>

                        <article className="kh-card kh-card-course">
                            <div className="kh-card-heading">
                                <span>Courses</span>
                                <h3>Udemy Courses</h3>
                            </div>
                            <p>
                                Deep-dive courses on AI, cloud, architecture, Python, Java, engineering leadership,
                                and interview preparation.
                            </p>

                            <a
                                href={udemyUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="kh-primary-link"
                            >
                                Explore Udemy courses
                            </a>
                        </article>

                    </div>

                    <aside className="kh-sidebar">
                        <article className="kh-card kh-card-article">
                            <div className="kh-card-heading">
                                <span>Articles</span>
                                <h3>Medium</h3>
                            </div>
                            <p>
                                Thought leadership on cloud, microservices, AI, architecture,
                                and engineering excellence.
                            </p>

                            <a
                                href={mediumUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="kh-primary-link"
                            >
                                Read articles
                            </a>
                        </article>

                        <article className="kh-card kh-card-newsletter">
                            <div className="kh-card-heading">
                                <span>Newsletter</span>
                                <h3>Tech That Matters</h3>
                            </div>
                            <p>
                                My LinkedIn newsletter exploring technology developments, practical
                                implications, and ideas that matter.
                            </p>

                            <a
                                href={newsletterUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="kh-primary-link kh-linkedin-button"
                            >
                                Subscribe on LinkedIn
                            </a>
                        </article>

                    </aside>

                </div>
            </div>
        </section>
    );
};

export default KnowledgeHub;
